import { newClient } from './axios-client-new';
import AES from "@/tools/AES.js";
import Vue from "vue";

// 获取用户区号信息
export const getCountryMsgAjax = function(phoneCountry) {
  return newClient().post('/api/h5/foundation/country/detail',{
    "phoneCountry":phoneCountry
  })
}
// 获取区号列表
export const getCountryCodeListAjax = function(phoneLang) {
  return newClient().post('/api/h5/foundation/country/multilingual/list',{
    "sysLanguage":phoneLang,
    "phoneLanguage":phoneLang,
  })
}

// 登录
export const loginAjax = function(json) {
  let jsonData = {
    ...json,
    timestamp:new Date().getTime(),
  };
  // type=google&eyJhbGciOiJSUzI1NiIsImtpZCI6IjFiYjc3NGJkODcyOWVhMzhlOWMyZmUwYzY0ZDJjYTk0OGJmNjZmMGYiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL2FjY291bnRzLmdvb2dsZS5jb20iLCJhenAiOiI2MDg1ODU5MTk4Mjgtamh2ajUycmJkdmdzbWVvcXRqbjlsZGU1amg2dWRscXUuYXBwcy5nb29nbGV1c2VyY29udGVudC5jb20iLCJhdWQiOiI2MDg1ODU5MTk4Mjgtamh2ajUycmJkdmdzbWVvcXRqbjlsZGU1amg2dWRscXUuYXBwcy5nb29nbGV1c2VyY29udGVudC5jb20iLCJzdWIiOiIxMDE1MDU3NTExNTMzMjMwNjc0MzQiLCJlbWFpbCI6ImppYWp3OTUyN0BnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwibmJmIjoxNzUwMzE5MDQzLCJuYW1lIjoiSlcgSmlhIiwicGljdHVyZSI6Imh0dHBzOi8vbGgzLmdvb2dsZXVzZXJjb250ZW50LmNvbS9hL0FDZzhvY0lJal95dzQwV20wTkJJdThUVlF6U21sZ2NMMEhtbGZqSHlaNDBzSmxnVy1pTUpTdz1zOTYtYyIsImdpdmVuX25hbWUiOiJKVyIsImZhbWlseV9uYW1lIjoiSmlhIiwiaWF0IjoxNzUwMzE5MzQzLCJleHAiOjE3NTAzMjI5NDMsImp0aSI6ImZlMWQ4Y2MwMzEyMjA0ODQ0YWUzYzJmMTkwOTIzY2UzMGEzODk4YTcifQ.H7mnkvGiN4kmTif3ChrZSghBYUpWpHaqxcopJCAjkJ6STqDIRHRKWEUebEnuddqSqwkMS9smsNCPRs0riKKletmkaARXM2cgvXbY80mmBHy-XC0DLxB4y6Jq-NmUuFYjMH1kFLAYcHSTBeKgrpJk7v4nKivpRAXPtxfRd1oZfMOf4eDCwFRlWjGNmckINaVE1nVQ-cPwrfXC7Q9ZLwGz4cPW9gIoX8TQQgz_1s0jjRdEeSVnIVD5vBDEnYvrYg_wAbzWmbZzlLQ5y9zA9ecj4vrt8EjW5-Ugo2PQR1i0yO0tSkcdOUHlaqfCE5cGxlbkqIBLOiP7AgBNvFLDfbDLog
  console.log('11111111122222222222',jsonData);
  let str = JSON.stringify(jsonData);
  var encrypts = AES.encrypt(str);
  console.log(encrypts);
  return newClient().post('/api/h5/user/auth/login',{
    sign:encrypts
  })
}

// 生成二维码
export const getQrcodeInfoAjax = function(){
  let time = new Date().getTime();
  let signText = AES.MD5jiami(time+'guochao@8859-1#$');
  return newClient().post('/api/h5/user/auth/qrcode/generate',{
    "key":signText.toUpperCase(),
    "timestamp":time,
  })
}
// 检查qrcode是否有效
export const checkQrcodeAjax = function({keyCode , platform}){
  let time = new Date().getTime();
  let signText = AES.MD5jiami(time+'guochao@8859-1#$');
  return newClient().post('/api/h5/user/auth/qrcode/pull',{
    "key":signText.toUpperCase(),
    "timestamp":time,
    "keyCode":keyCode,
    "platform":platform
  })
}

// 判断是否是币商
export const getIsSellerAjax = function(){
  return newClient().post('/api/h5/token/trade/account/traderState')
}
/**
 * 获取dukpay美元和本地货币的转换汇率
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getDukpayRatio = function(countryId){
  return newClient().post('/api/h5/trade/dukPay/payIn/getRate', { countryId: countryId });
}
/**
 * 获取当前ip所在的国家 coding
 */
export const getCountryByIp = function(countryId){
  return newClient("gchao").get('/web/h5/getCountryByIp', { countryId: countryId });
}





// WEBPACK FOOTER //
// ./src/api/index.js